import React from 'react';
import { AuthTemplate } from '../../../components/Auth/AuthTemplate';
import { SignupForm } from '../../../components/Auth/SignupForm';

const Signup = () => {
  return (
    <AuthTemplate
      footer={{
        title: 'Already have an account?',
        buttonText: 'Sign in',
        buttonUrl: '/login',
      }}
    >
      <SignupForm />
    </AuthTemplate>
  );
};

export default Signup;
